module.exports = __webpack_public_path__ + "img/baoxiao.57d78f6e.png";